<template>
  <div class="score_rule_container">
    <div class="score_rule_box">
      <div class="h2">个人积分获取规则</div>
      <div class="rule_list">
        <p>1. 每日签到</p>
        <p>登录状态下点击签到按钮</p>
        <p>连续签到1—3天，每天加1积分</p>
        <p>连续签到4—6天，每天加2积分</p>
        <p>连续签到7天，每天加3积分</p>
        <p>连续签到大于7天，每天加4积分</p>
        <p>断签从头开始计算</p>
        <p>2. 阅读1篇图文稿件，加1积分，每日上限为5积分</p>
        <p>3. 阅读1篇视频稿件，加2积分，每日上限为6积分</p>
        <p>4. 评论1篇稿件，加1积分，每日上限为5积分</p>
        <p>5. 转发1篇稿件，加1积分，每日上限为3积分</p>
        <p>6. 点赞1篇稿件，加1积分，每日上限为5积分</p>
        <p>7. 订阅1个入驻号，加1积分，每日上限为5积分</p>
        <p>8. 收藏1篇稿件，加1积分，每日上限为3积分</p>
        <p>9. 参与投票1次，加3积分，每日上限为3积分</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "ScoreRule",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, "个人积分获取规则 - 法治号客户端", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = "个人积分获取规则";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.score_rule_container {
  width: 100%;
  height: 100%;
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #000;
  * {
    word-break: normal;
    white-space: normal;
    line-height: 24px;
    font-family: "Microsoft Yahei";
  }
  .score_rule_box {
    .h2 {
      padding: 18px 0;
      text-align: center;
      font-size: 18px;
      font-weight: bolder;
    }
    .rule_list {
      p {
        margin: 10px 0;
        line-height: 27px;
        text-indent: 2em;
        font-size: 16px;
      }
    }
  }
}
</style>